import { grey900 } from './palette';
import './index.css';

export const typography = {
  fontFamily: ['-apple-system', "'Work Sans'", 'sans-serif'].join(','),
  htmlFontSize: 10,
  allVariants: {
    color: grey900,
  },
  h1: {
    fontSize: '30px',
    lineHeight: '40px',
    fontWeight: '600',
    letterSpacing: '-0.63px',
  },
  h2: {
    fontSize: '24px',
    lineHeight: '32px',
    fontWeight: '600',
    letterSpacing: '-0.456px',

    '@media (max-width:768px)': {
      fontSize: '20px',
    },
  },
  h3: {
    fontSize: '20px',
    lineHeight: '32px',
    fontWeight: '600',
    letterSpacing: '-0.34px',
  },
  h4: {
    fontSize: '20px',
    lineHeight: '32px',
    fontWeight: '400',
    letterSpacing: '-0.34px',

    '@media (max-width:768px)': {
      fontSize: '16px',
      lineHeight: '24px',
    },
  },
  h5: {
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: '400',
    letterSpacing: '-0.252px',
  },
  textLarge: {
    fontSize: '18px',
    lineHeight: '24px',
    letterSpacing: '-0.252px',
  },
  textMedium: {
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '-0.176px',
  },
  textSmall: {
    fontSize: '14px',
    lineHeight: '24px',
    fontWeight: '400',
    letterSpacing: '-0.084px',
  },
};
